import { Select } from "antd";
import { FC, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { getSemesters } from "../api/semesters.api";
import useAxios from "../hooks/useAxios";
import { IGetSemesters } from "../models/semesters.model";
import ErrorResponse from "./ErrorResponse";
import Loader from "./Loader";

interface IProps {
  semesterCode: number|undefined;
  setSemesterCode: (semesterCode: number) => void;
  setSemesterOptions?: (options: any) => void;
}

const SelectSemester: FC<IProps> = ({
  semesterCode,
  setSemesterCode,
  setSemesterOptions,
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetSemesters>();

  useEffect(() => {
    execute(getSemesters());
  }, []);

  return (
    <>
      {isLoading && <Loader isInBox={true} />}
      <ErrorResponse error={error} />
      <Select
        placeholder={t('class.class.placeholder4')}
        value={semesterCode}
        onChange={(value, options) => {
          setSemesterCode(value);
          if (setSemesterOptions) {
            setSemesterOptions(options);
          }
        }}
      >
        {res?.data?.map((item) => (
          <Select.Option
            key={item.semesterCode}
            record={item}
            value={item.semesterCode}
          >
            {item.semesterName}
          </Select.Option>
        ))}
      </Select>
    </>
  );
};

export default SelectSemester;
